import React, { useEffect, useRef } from "react";

const HCaptchaManual = ({ sitekey, onVerify, onExpire, onError }) => {
  const captchaRef = useRef(null);
  const widgetId = useRef(null);

  useEffect(() => {
    const renderCaptcha = () => {
      if (window.hcaptcha && captchaRef.current && widgetId.current === null) {
        widgetId.current = window.hcaptcha.render(captchaRef.current, {
          sitekey,
          callback: onVerify,
          "expired-callback": onExpire,
          "error-callback": onError,
        });
      }
    };

    if (!window.hcaptcha) {
      const script = document.createElement("script");
      script.src = "https://hcaptcha.com/1/api.js?render=explicit";
      script.async = true;
      script.defer = true;
      script.onload = renderCaptcha;
      document.body.appendChild(script);
    } else {
      renderCaptcha();
    }
  }, [sitekey, onVerify, onExpire, onError]);

  return <div ref={captchaRef} style={{ height: "80px" }} />;
};

export default HCaptchaManual;
